/* global window, sessionStorage */
import { useEffect, useState } from 'react';
import { useReadSessionStorage } from './useReadSessionStorage';
import { useReadLocalStorage } from './useReadLocalStorage';
var isDebugHost = function () {
    var hostname = (window === null || window === void 0 ? void 0 : window.location).hostname;
    return hostname === 'localhost' || hostname === 'citrus-staging.paylocity.com';
};
/**
 * Hook for determining if citrus components should be in debug mode
 * @example
 * const debug = useCitrusDebug();
 */
export var useCitrusDebug = function () {
    var _a = useState(false), debug = _a[0], setDebug = _a[1];
    var debugSession = useReadSessionStorage('citrus-debug', 'false');
    var debugLocal = useReadLocalStorage('citrus-debug', 'false');
    useEffect(function () {
        if (isDebugHost()) {
            sessionStorage.setItem('citrus-debug', 'true');
        }
        setDebug(debugSession.toString() === 'true' || debugLocal.toString() === 'true');
    }, []);
    return debug;
};
